import { create } from 'zustand'
import { User } from './types'

/**
 * Состояние пользователя
 * 
 * Хранит информацию о текущем пользователе, состояние авторизации
 * и состояние загрузки/ошибок.
 */
interface UserState {
  user: User | null
  isLoading: boolean
  error: string | null
  isAuthenticated: boolean
  
  // Действия
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clearUser: () => void
}

/**
 * Store для пользователя (Zustand)
 * 
 * Глобальное состояние текущего пользователя. Синхронизируется с API
 * через useUser hook.
 * 
 * @example
 * ```tsx
 * const { user, isAuthenticated, setUser } = useUserStore()
 * 
 * // Проверить авторизацию
 * if (isAuthenticated) {
 *   // Пользователь авторизован
 * }
 * ```
 */
export const useUserStore = create<UserState>((set) => ({
  user: null,
  isLoading: false,
  error: null,
  isAuthenticated: false,

  setUser: (user) => set({ 
    user, 
    isAuthenticated: !!user 
  }),
  
  setLoading: (isLoading) => set({ isLoading }),
  
  setError: (error) => set({ error }),
  
  clearUser: () => set({
    user: null,
    isAuthenticated: false,
    error: null,
  }),
}))

